import { render, staticRenderFns } from "./DesktopBeachTypeFilter.vue?vue&type=template&id=692c9954&"
import script from "./DesktopBeachTypeFilter.vue?vue&type=script&lang=ts&setup=true&"
export * from "./DesktopBeachTypeFilter.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports